import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const walletKeys = {
    all: ['wallet'],
    get: () => ['wallet', 'details'],
    transactions: (filter) => ['wallet', 'transactions', filter],
};
export const walletOptions = {
    get: () => queryOptions({
        queryKey: walletKeys.get(),
        queryFn: async () => {
            const repository = await resolveRepository(Domain.Wallet);
            const [wallet] = await repository.get();
            return wallet ?? null;
        },
    }),
    transactions: (filter) => queryOptions({
        queryKey: walletKeys.transactions(filter),
        queryFn: async () => {
            const repository = await resolveRepository(Domain.Wallet);
            return repository.getTransactions(filter);
        },
    }),
    topUp: () => ({
        mutationFn: async (request) => {
            const repository = await resolveRepository(Domain.Wallet);
            return repository.topUp(request);
        },
    }),
};
